const uriToShowcaseId = (uri: string) => {
  let showcaseId;
  const match = uri.match(/albums\/\d+/g);
  if (match) {
    showcaseId = match[0].split('/').pop() as string;
  }
  return showcaseId;
};

export const uriToShowcaseLink = (uri: string) => {
  const id = uriToShowcaseId(uri);
  return id ? `/manage/showcases/${id}` : '/library/showcases';
};
